export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M9 6.25h6V3h7v8h-7V7.75h-2.25v8.5H15V13h7v8h-7v-3.25h-3.75v-10H9V11H2V3h7v3.25Zm7.5 13.25h4v-5h-4v5Zm-13-10h4v-5h-4v5Zm13 0h4v-5h-4v5Z"/>
</svg>
`;
